import React, { useState, useEffect } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import CheckCircleTwoToneIcon from '@mui/icons-material/CheckCircleTwoTone';
import IntlMessages from 'lngProvider/IntlMessages';
import PublicHeader from 'components/PublicHeader';
import FooterWrapper from 'components/Footer';
import SignInService from 'services/SignInService';
import { styled } from '@mui/material/styles';
import { getPaperStyleObject } from 'styles/Paper';
import useQueryParams from 'hooks/useQueryParams';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
        return {
            ...paperStyle.root
        };
    });

const ResetPassword = () => {
    const [loginConfig, setLoginConfig] = useState(null);
    const { getQueryParamByName } = useQueryParams();

    useEffect(() => {
        const fetchData = () => {
            const returnUrl = getQueryParamByName('ReturnUrl');

            SignInService.getLogInConfig(returnUrl).then(data => setLoginConfig(data));
        };

        fetchData();

    }, [getQueryParamByName]);

    document.title = "3M - Reset Password Confirmation";

    setTimeout(() => {
        const redirectUrl = getQueryParamByName('redirectUrl');
        window.location.replace(redirectUrl);
    }, 3000);

    return (
        <section>
            {loginConfig && loginConfig.showPublicHeader === true ?
                <PublicHeader />
            : ''}
            <Grid container alignItems="center" justifyContent="center">
                <Grid item>
                    <StyledPaper>
                        <Grid container spacing={4}>
                            <Grid item xs={12}>
                                <div className="text-center text-success"><CheckCircleTwoToneIcon fontSize="large" color="inherit" /></div>
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="h4"><IntlMessages id="resetPassword.hasBeenReset" /></Typography>
                                <Typography variant="subtitle2"><IntlMessages id="resetPassword.redirecting" /></Typography>
                            </Grid>
                        </Grid>
                    </StyledPaper>
                </Grid>
            </Grid>
            <FooterWrapper />
        </section>
    );
};

export default ResetPassword;